/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const repeatMobileOrderComboModifierSchema = z.object({
	id: z.uuid().nullish(),
	amount: z.int(),
});
